module.exports = __webpack_public_path__ + "static/kitchen_2K-3dd3c99951f558b735c27d9cf7dfc5a2.jpg";